(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.helphero = factory());
}(this, (function () { 'use strict';

  var methods = [
      "startTour",
      "advanceTour",
      "cancelTour",
      "identify",
      "anonymous",
      "update",
      "on",
      "off",
      "openLauncher",
      "closeLauncher"
  ];
  var initializedAppId;
  var instance;
  function initHelpHero(appId) {
      if (typeof appId !== "string" || appId === "") {
          throw new Error("Invalid HelpHero App ID: " + appId);
      }
      if (initializedAppId != null && initializedAppId !== appId) {
          throw new Error("HelpHero does not support initializing multiple Apps on the same page. Trying to initialize with App ID \"" + initializedAppId + "\" which is different from previously used App ID \"" + appId + "\"");
      }
      if (instance != null) {
          return instance;
      }
      // create temporary tasks
      var tasks = [];
      var queue = function () {
          tasks.push(arguments);
      };
      queue.q = tasks;
      window.HelpHero = queue;
      // add script to page
      var script = document.createElement("script");
      var hasHttp = /^https?:$/.test(document.location.protocol || "");
      script.src = (hasHttp ? "" : "https:") + "//app.helphero.co/embed/" + appId;
      script.async = true;
      document.body.appendChild(script);
      // return API wrapper
      initializedAppId = appId;
      instance = Object.create(null);
      methods.forEach(function (method) {
          instance[method] = function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
              }
              // @ts-ignore
              return window.HelpHero.apply(null, [method].concat(args));
          };
      });
      return instance;
  }

  return initHelpHero;

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/helphero/dist/helphero.js
// module id = 5+/K
// module chunks = 0